import { render, staticRenderFns } from "./MobileClass.vue?vue&type=template&id=4dcae9ea&scoped=true"
import script from "./MobileClass.vue?vue&type=script&lang=js"
export * from "./MobileClass.vue?vue&type=script&lang=js"
import style0 from "./MobileClass.vue?vue&type=style&index=0&id=4dcae9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcae9ea",
  null
  
)

export default component.exports